import api from "./httpService";

export type CourtAvailability = {
    day: string;
    startTime: string;
    endTime: string;
};

export type Court = {
    _id: string;
    name: string;
    availability: CourtAvailability[];
    status: boolean;
};

export type BookingMember = {
    _id: string;
    firstName: string;
    lastName: string;
    mobile?: string;
    status?: boolean;
};

export type CourtBooking = {
    _id: string;
    court: Court;
    member: BookingMember;
    date: string;
    startTime: string;
    endTime: string;
    status: "Booked" | "Cancelled";
    notes?: string;
};

export type CourtPayload = {
    name: string;
    availability: CourtAvailability[];
    status: boolean;
};

export type CourtBookingPayload = {
    court: string;
    member: string;
    date: string;
    startTime: string;
    endTime: string;
    notes?: string;
};

export const getCourts = async (includeInactive = false): Promise<Court[]> => {
    const response = await api.get(`/courts${includeInactive ? "?includeInactive=true" : ""}`);
    return response.data;
};

export const addCourt = async (payload: CourtPayload): Promise<Court> => {
    const response = await api.post("/courts", payload);
    return response.data;
};

export const updateCourt = async (courtId: string, payload: CourtPayload): Promise<Court> => {
    const response = await api.put(`/courts/${courtId}`, payload);
    return response.data;
};

export const deleteCourt = async (courtId: string) => {
    const response = await api.delete(`/courts/${courtId}`);
    return response.data;
};

export const getCourtBookings = async (): Promise<CourtBooking[]> => {
    const response = await api.get("/bookings");
    return response.data;
};

export const getCourtBookingOptions = async (): Promise<{ courts: Court[]; members: BookingMember[] }> => {
    const response = await api.get("/bookings/options");
    return response.data;
};

export const addCourtBooking = async (payload: CourtBookingPayload): Promise<CourtBooking> => {
    const response = await api.post("/bookings", payload);
    return response.data;
};

export const cancelCourtBooking = async (bookingId: string): Promise<CourtBooking> => {
    const response = await api.put(`/bookings/${bookingId}`, { status: "Cancelled" });
    return response.data;
};
